import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import { StyledButton }  from '@mlb/react-patterns/components/Button/button.style.tsx';

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 18px 16px;

    ${StyledButton} {
        height: auto;
        padding: 3px 0 0 0;
    }

    ${media.lgmin`
        padding: 18px 20px 18px 32px;
    `}
`;

export const Title = styled.h1`
    color: ${COLORS.mlbWhite};
    font-family: ${FONTS.primaryFont};
    font-size: 25px;
    font-weight: bold;
    margin: 0;
    ${media.lgmin`
        font-size: 21px;
    `}
`;
